function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareBubbleChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.749,
    height: 16,
    viewBox: "0 0 16.749 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 150349",
    d: "M8.791 20.918a1.376 1.376 0 0 0 .93-.492l2.79-2.518 4.945.008a3.239 3.239 0 0 0 3.554-3.561V8.479a3.239 3.239 0 0 0-3.554-3.561h-9.64a3.242 3.242 0 0 0-3.554 3.561v5.875a3.235 3.235 0 0 0 3.5 3.554h.3V20.1c.003.5.268.818.729.818z",
    transform: "translate(-4.262 -4.918)",
    style: {
      fill: "#7e27e4"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareBubbleChat);
export default __webpack_public_path__ + "static/media/square-bubble-chat.eddfa8d8.svg";
export { ForwardRef as ReactComponent };